import { BsFillDoorClosedFill } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import { resetContactState  } from '../../slices/contactAddressSlice'
import { useDispatch } from 'react-redux'
import userRole from '../../config/userRole'
import { useProcessAuth } from '../../hooks/fetch/auth/useProcessAuth'
import useCurrentPath from '../../hooks/useCurrentPath'
import useLoggedInUser from '../../hooks/useLoggedInUser'
import { logoutUser } from '../../slices/authSlice'
import IconText from '../UtilComponent/level_1/IconText'

const HeaderContents = () => {
  const dispatch = useDispatch()

  const { loggedInUser } = useLoggedInUser()
  const { currentPath } = useCurrentPath()

  const { logoutAuth } = useProcessAuth()

  return currentPath !== 'login' ? (
    <div className="text-small">
      {loggedInUser.username &&
        (loggedInUser.role === userRole['一般ユーザー'] ? (
          <span>
            【ログイン中】 {loggedInUser.companyName} {loggedInUser.username}
            さん
          </span>
        ) : (
          <span>【ログイン中】 {loggedInUser.companyName} さん</span>
        ))}
      <Link
        to=""
        onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
          const isOK = window.confirm(`ログアウトをしてよろしいでしょうか？`)
          if (isOK) {
            dispatch(logoutUser())
            dispatch(resetContactState())
            logoutAuth(e)
          } else {
            e.preventDefault()
          }
        }}
        style={{ marginLeft: '2rem' }}
      >
        <IconText Icon={BsFillDoorClosedFill} text="ログアウト" />
      </Link>
    </div>
  ) : (
    <span></span>
  )
}

export default HeaderContents
